import { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { AuthService, Profile } from '../services/auth.service';

/**
 * Hook to track active collaborators in a specific channel (e.g. a batch)
 */
export const usePresence = (channelId: string) => {
    const [presence, setPresence] = useState<any[]>([]);
    const [user, setUser] = useState<Profile | null>(null);

    useEffect(() => {
        const init = async () => {
            const { data } = await AuthService.getCurrentUser();
            setUser(data);
        };
        init();
    }, []);

    useEffect(() => {
        if (!channelId || !user) return;

        const channel = supabase.channel(`presence:${channelId}`, {
            config: {
                presence: {
                    key: user.id,
                },
            },
        });

        channel
            .on('presence', { event: 'sync' }, () => {
                const state = channel.presenceState();
                const flattened = Object.values(state).flat();
                setPresence(flattened);
            })
            .on('presence', { event: 'join' }, ({ key, newPresences }) => {
                console.log('Join:', key, newPresences);
            })
            .on('presence', { event: 'leave' }, ({ key, leftPresences }) => {
                console.log('Leave:', key, leftPresences);
            })
            .subscribe(async (status) => {
                if (status === 'SUBSCRIBED') {
                    await channel.track({
                        id: user.id,
                        full_name: user.full_name || user.email,
                        role: user.role,
                        online_at: new Date().toISOString(),
                    });
                }
            });

        return () => {
            channel.unsubscribe();
        };
    }, [channelId, user]);

    return { presence };
};
